var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_55",
  "data-name": "Group 55",
  transform: "translate(0.496 0.203)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_37",
  "data-name": "Rectangle 37",
  width: 40,
  height: 40,
  rx: 20,
  transform: "translate(-0.496 -0.203)",
  fill: "#008c45"
}), /*#__PURE__*/React.createElement("g", {
  id: "linkedin-logo",
  transform: "translate(13.565 14.002)"
}, /*#__PURE__*/React.createElement("path", {
  id: "LinkedIn",
  d: "M18,20.1v6.655H14.142V20.549c0-1.56-.558-2.624-1.954-2.624a2.111,2.111,0,0,0-1.979,1.411,2.64,2.64,0,0,0-.128.941v6.481H6.221s.052-10.516,0-11.606H10.08V16.8c-.008.012-.018.026-.025.037h.025V16.8a3.832,3.832,0,0,1,3.478-1.918C16.1,14.88,18,16.539,18,20.1ZM2.184,9.558a2.011,2.011,0,1,0-.051,4.011h.026a2.012,2.012,0,1,0,.025-4.011ZM.229,26.758H4.087V15.152H.229Z",
  transform: "translate(-2.061 -12.763)",
  fill: "#fff"
})));
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d095a169d5092519249180bcf480e3a7.svg";
export { ForwardRef as ReactComponent };